import _toConsumableArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import { useReducer, useCallback } from 'react';
import { createStandardAction, getType } from 'typesafe-actions';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var ACTION_TYPES;

(function (ACTION_TYPES) {
  ACTION_TYPES["PUSH"] = "PUSH";
  ACTION_TYPES["POP"] = "POP";
  ACTION_TYPES["UNSHIFT"] = "UNSHIFT";
  ACTION_TYPES["SHIFT"] = "SHIFT";
  ACTION_TYPES["SPLICE"] = "SPLICE";
  ACTION_TYPES["UPDATE"] = "UPDATE";
  ACTION_TYPES["SET"] = "SET";
  ACTION_TYPES["INSERT"] = "INSERT";
  ACTION_TYPES["MOVE"] = "MOVE";
  ACTION_TYPES["REMOVE"] = "REMOVE";
  ACTION_TYPES["SWAP"] = "SWAP";
})(ACTION_TYPES || (ACTION_TYPES = {}));

var push = createStandardAction(ACTION_TYPES.PUSH)();
var pop = createStandardAction(ACTION_TYPES.POP)();
var unshift = createStandardAction(ACTION_TYPES.UNSHIFT)();
var shift = createStandardAction(ACTION_TYPES.SHIFT)();
var splice = createStandardAction(ACTION_TYPES.SPLICE)();
var update = createStandardAction(ACTION_TYPES.UPDATE)();
var set = createStandardAction(ACTION_TYPES.SET)();
var insert = createStandardAction(ACTION_TYPES.INSERT)();
var move = createStandardAction(ACTION_TYPES.MOVE)();
var remove = createStandardAction(ACTION_TYPES.REMOVE)();
var swap = createStandardAction(ACTION_TYPES.SWAP)();

var reducer = function reducer(state, action) {
  switch (action.type) {
    case getType(push):
      return [].concat(_toConsumableArray(state), [action.payload]);

    case getType(pop):
      return state.slice(0, state.length - 1);

    case getType(unshift):
      return [action.payload].concat(_toConsumableArray(state));

    case getType(shift):
      return state.slice(1, state.length);

    case getType(splice):
      {
        var nextState = _toConsumableArray(state);

        nextState.splice.apply(nextState, _toConsumableArray(action.payload));
        return nextState;
      }

    case getType(update):
      {
        var _nextState = _toConsumableArray(state);

        _nextState[action.payload.index] = action.payload.value;
        return _nextState;
      }

    case getType(set):
      return action.payload;

    case getType(insert):
      {
        var _nextState2 = _toConsumableArray(state);

        _nextState2.splice(action.payload.index, 0, action.payload.value);

        return _nextState2;
      }

    case getType(move):
      {
        var _nextState3 = _toConsumableArray(state);

        if (action.payload.to >= _nextState3.length) {
          var i = action.payload.to - _nextState3.length + 1;

          while (i--) {
            _nextState3.push(undefined);
          }
        }

        _nextState3.splice(action.payload.to, 0, _nextState3.splice(action.payload.from, 1)[0]);

        return _nextState3;
      }

    case getType(remove):
      {
        var _nextState4 = _toConsumableArray(state);

        _nextState4.splice(action.payload, 1);

        return _nextState4;
      }

    case getType(swap):
      {
        var _nextState5 = _toConsumableArray(state);

        var largestIndex = Math.max.apply(Math, _toConsumableArray(action.payload));

        if (largestIndex >= _nextState5.length) {
          var _i2 = largestIndex - _nextState5.length + 1;

          while (_i2--) {
            _nextState5.push(undefined);
          }
        }

        var _ref = [_nextState5[action.payload[1]], _nextState5[action.payload[0]]];
        _nextState5[action.payload[0]] = _ref[0];
        _nextState5[action.payload[1]] = _ref[1];
        return _nextState5;
      }

    default:
      return state;
  }
};

function useArrayState(initialState) {
  var _useReducer = useReducer(reducer, initialState || []),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var boundActions = {
    push: useCallback(function (value) {
      return dispatch(push(value));
    }, []),
    pop: useCallback(function () {
      return dispatch(pop());
    }, []),
    unshift: useCallback(function (value) {
      return dispatch(unshift(value));
    }, []),
    shift: useCallback(function () {
      return dispatch(shift());
    }, []),
    splice: useCallback(function (start, deleteCount) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return dispatch(splice([start, deleteCount].concat(args)));
    }, []),
    update: useCallback(function (index, value) {
      return dispatch(update({
        index: index,
        value: value
      }));
    }, []),
    set: useCallback(function (value) {
      return dispatch(set(value));
    }, []),
    insert: useCallback(function (index, value) {
      return dispatch(insert({
        index: index,
        value: value
      }));
    }, []),
    move: useCallback(function (from, to) {
      return dispatch(move({
        from: from,
        to: to
      }));
    }, []),
    remove: useCallback(function (index) {
      return dispatch(remove(index));
    }, []),
    swap: useCallback(function (indexA, indexB) {
      return dispatch(swap([indexA, indexB]));
    }, [])
  };
  return [state, boundActions];
}

export default useArrayState;
export { reducer };